import React from 'react';
import classNames from 'classnames';
import DropdownButton from '../dropdowns/DropdownButton';
import DropdownItem from '../dropdowns/DropdownItem';
import { US_STATES_BOUNDS } from '../../../constants.js'

const FilterStateOpen = (props) => {

    const { toggleCongressDropdowns, congress, chooseDropdownItem, active, isMobile } = props;
    const propsValue = `state-${congress.filterDistrict.state}`;

    const mapStates = () => US_STATES_BOUNDS.map(state =>
        <DropdownItem
            key={state.abrv}
            func={chooseDropdownItem}
            id={state.abrv}
            name={`${state.abrv  }.${  state.state}`}
            type="state"
            selectedItem={congress.selected.stateName}
        />);

    return (
        <>
            <DropdownButton
                name={isMobile ? congress.selected.abrvState : congress.selected.stateName}
                callFunction={toggleCongressDropdowns}
                callVal={propsValue}
                chevron={congress.filterDistrict.state ? 'up' : 'down'}
                active={active}
                expanded={congress.filterDistrict.state}
                isMobile={isMobile}
                id="us-state-filter"
            />

            <div className={classNames('list-dropdown', { 'open': congress.filterDistrict.state })}>
                <ul className="list-group">
                    {mapStates()}
                </ul>
            </div>
        </>
    );

};

export default FilterStateOpen;
